"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var SalesForceButtonArea = /** @class */ (function (_super) {
    __extends(SalesForceButtonArea, _super);
    function SalesForceButtonArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesForceButtonArea.prototype.mounted = function () {
        this.documentId = this.$route.params['documentId'];
    };
    SalesForceButtonArea.prototype.reCorrectUrlButtonClick = function (event) {
        event.preventDefault();
        this.$emit('re-correct');
    };
    SalesForceButtonArea.prototype.reflectButtonClick = function (event) {
        event.preventDefault();
        this.$emit('reflect', event);
    };
    SalesForceButtonArea.prototype.csvOutputButtonClick = function (event) {
        event.preventDefault();
        this.$emit('csv-output');
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], SalesForceButtonArea.prototype, "reflectType", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], SalesForceButtonArea.prototype, "disableCsvOutput", void 0);
    SalesForceButtonArea = __decorate([
        vue_property_decorator_1.Component({
            components: { SimpleDialog: SimpleDialog_1.default }
        })
    ], SalesForceButtonArea);
    return SalesForceButtonArea;
}(vue_property_decorator_1.Vue));
exports.default = SalesForceButtonArea;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/SalesForceButtonArea.vue
// module id = gzKU
// module chunks = 1